import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer>
      <p>© 2025 Arctic Racing Society</p>
    </footer>
  );
};

export default Footer;